module.exports = __webpack_public_path__ + "media/img/uploads/press-news-article-temp-01-bde1cba6e157b6f88fe8149262b1b530.jpg";